import { jsxs as d, jsx as n } from "react/jsx-runtime";
import { forwardRef as B, useRef as N, useCallback as p, useState as W, useEffect as _, useMemo as E } from "react";
import { F as I } from "./FilterChip-CWAMqAnU.js";
import { S as K } from "./ScrollArea-BE3owCA_.js";
import { T as f } from "./Tabs-p-MQ_Ra9.js";
import { C as Y } from "./ConvRow-DAa4On4H.js";
const q = {
  display: "flex",
  flexDirection: "column",
  background: "var(--bg-surface)",
  borderRight: "1px solid var(--border-subtle)",
  fontFamily: "var(--font-sans)",
  height: "100%",
  minHeight: 0
}, F = {
  borderBottom: "1px solid var(--border-subtle)",
  padding: "var(--space-3) var(--space-3)",
  display: "flex",
  flexDirection: "column",
  gap: "var(--space-2)"
}, P = {
  fontSize: "var(--text-2xs)",
  lineHeight: "var(--line-xs)",
  letterSpacing: "var(--tracking-uppercase)",
  textTransform: "uppercase",
  color: "var(--text-tertiary)",
  fontWeight: 600
}, U = B(function({
  accounts: v,
  selectedAccount: w,
  onAccountChange: C,
  modeTab: L,
  onModeTabChange: S,
  modeTabs: D,
  accountStatusBanner: k,
  headerActions: g,
  items: t,
  selectedId: c,
  onSelect: M,
  emptyState: T,
  labels: o = {},
  width: H = 262
}, z) {
  const h = o.region ?? "Conversations", O = o.listbox ?? h, x = N(/* @__PURE__ */ new Map()), j = p(
    (e) => (r) => {
      r ? x.current.set(e, r) : x.current.delete(e);
    },
    []
  ), [s, y] = W(c ?? t[0]?.id ?? null);
  _(() => {
    s && t.some((e) => e.id === s) || y(c ?? t[0]?.id ?? null);
  }, [t, c, s]);
  const m = E(() => s ? t.findIndex((e) => e.id === s) : -1, [t, s]), b = E(() => {
    const e = /* @__PURE__ */ new Map();
    for (const r of v) e.set(r.id, r);
    return e;
  }, [v]), R = p(
    (e) => {
      const r = t[e];
      return r ? b.get(r.accountId)?.status === "paused" : !0;
    },
    [t, b]
  ), l = p(
    (e, r) => {
      let a = e;
      for (; a >= 0 && a < t.length && R(a); )
        a += r;
      if (a < 0 || a >= t.length) return;
      const i = t[a];
      i && (y(i.id), requestAnimationFrame(() => {
        x.current.get(i.id)?.focus();
      }));
    },
    [t, R]
  ), A = p(
    (e) => {
      switch (e.key) {
        case "ArrowDown":
          e.preventDefault(), l(Math.min(t.length - 1, m + 1), 1);
          break;
        case "ArrowUp":
          e.preventDefault(), l(Math.max(0, m - 1), -1);
          break;
        case "Home":
          e.preventDefault(), l(0, 1);
          break;
        case "End":
          e.preventDefault(), l(t.length - 1, -1);
          break;
      }
    },
    [m, t.length, l]
  );
  return /* @__PURE__ */ d(
    "section",
    {
      ref: z,
      "aria-label": h,
      "data-ls-component": "conv-list",
      style: { ...q, width: H },
      children: [
        /* @__PURE__ */ d("div", { style: F, "data-ls-region": "account-filter", children: [
          o.accountFilterEyebrow || g ? /* @__PURE__ */ d(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "var(--space-2)",
                minHeight: "var(--space-4)"
              },
              children: [
                o.accountFilterEyebrow ? /* @__PURE__ */ n("div", { style: P, children: o.accountFilterEyebrow }) : /* @__PURE__ */ n("span", {}),
                g ? /* @__PURE__ */ n(
                  "div",
                  {
                    "data-ls-region": "header-actions",
                    style: { display: "flex", alignItems: "center" },
                    children: g
                  }
                ) : null
              ]
            }
          ) : null,
          /* @__PURE__ */ d("div", { style: { display: "flex", flexWrap: "wrap", gap: "var(--space-1)" }, children: [
            /* @__PURE__ */ n(
              I,
              {
                size: "xs",
                tone: "neutral",
                selected: w === "all",
                onClick: () => C("all"),
                children: o.allAccountsLabel ?? "All accounts"
              }
            ),
            v.map((e) => {
              const r = e.status !== "active", a = e.status === "error" ? "var(--color-error)" : e.status === "limited" || e.status === "paused" ? "var(--color-warning)" : "transparent", i = [];
              r && i.push(e.status), typeof e.statusInfo == "string" && i.push(e.statusInfo);
              const u = i.length > 0 ? i.join(" — ") : void 0;
              return /* @__PURE__ */ n(
                I,
                {
                  size: "xs",
                  tone: "neutral",
                  selected: w === e.id,
                  onClick: () => C(e.id),
                  "data-account-status": e.status,
                  title: u,
                  icon: r ? /* @__PURE__ */ n(
                    "span",
                    {
                      "data-status-dot": e.status,
                      "aria-hidden": "true",
                      style: {
                        display: "inline-block",
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        background: a
                      }
                    }
                  ) : void 0,
                  children: e.name
                },
                e.id
              );
            })
          ] })
        ] }),
        /* @__PURE__ */ n("div", { style: F, "data-ls-region": "mode-tabs", children: /* @__PURE__ */ d(
          f,
          {
            value: L,
            onValueChange: (e) => S(e),
            variant: "pills",
            size: "sm",
            children: [
              /* @__PURE__ */ n(f.List, { "aria-label": h, children: D.map((e) => /* @__PURE__ */ n(f.Trigger, { value: e.value, count: e.count, icon: e.icon, children: e.label }, e.value)) }),
              D.map((e) => /* @__PURE__ */ n(
                f.Content,
                {
                  value: e.value,
                  hidden: !0,
                  forceMount: !0,
                  style: { display: "none" }
                },
                e.value
              ))
            ]
          }
        ) }),
        k ? /* @__PURE__ */ n("div", { style: { padding: "var(--space-3) var(--space-3)" }, children: k }) : null,
        /* @__PURE__ */ n(
          "div",
          {
            style: {
              flex: "1 1 auto",
              minHeight: 0,
              display: "flex",
              flexDirection: "column"
            },
            children: t.length === 0 ? T ?? /* @__PURE__ */ n(
              "div",
              {
                style: {
                  padding: "var(--space-6) var(--space-4)",
                  textAlign: "center",
                  color: "var(--text-tertiary)",
                  fontSize: "var(--text-sm)"
                },
                role: "status",
                children: o.noResults ?? "No conversations"
              }
            ) : /* @__PURE__ */ n(K, { orientation: "vertical", style: { flex: "1 1 auto", minHeight: 0 }, children: /* @__PURE__ */ n(
              "div",
              {
                role: "listbox",
                "aria-label": O,
                "data-ls-region": "listbox",
                onKeyDown: A,
                tabIndex: -1,
                style: { display: "flex", flexDirection: "column", padding: "var(--space-1)" },
                children: t.map((e) => {
                  const r = b.get(e.accountId), a = r?.mode ?? "manual", i = r?.status === "paused";
                  return /* @__PURE__ */ n(
                    Y,
                    {
                      ref: j(e.id),
                      conv: e,
                      selected: e.id === c,
                      accountMode: a,
                      onSelect: (u) => {
                        y(u), M(u);
                      },
                      disabled: i,
                      tabIndex: e.id === s ? 0 : -1
                    },
                    e.id
                  );
                })
              }
            ) })
          }
        )
      ]
    }
  );
});
U.displayName = "ConvList";
export {
  U as C
};
//# sourceMappingURL=ConvList-BDQ6wDVI.js.map
